/**
 * OFIYAA scroll reveal animations
 *
 * Self reveal: class "ofiyaa-reveal" on the element
 * Group reveal: data-ofiyaa-reveal-root on container; reveals child ".ofiyaa-reveal" elements
 * Stagger: --ofiyaa-reveal-delay on reveal elements
 */
(() => {
  const REVEAL_SELECTOR = '.ofiyaa-reveal';
  const ROOT_SELECTOR = '[data-ofiyaa-reveal-root]';
  const VISIBLE_CLASS = 'is-visible';

  const observerOptions = {
    rootMargin: '0px 0px -5% 0px',
    threshold: 0.1,
  };

  let observer;

  function revealElement(element) {
    element.classList.add(VISIBLE_CLASS);
  }

  function revealChildren(root) {
    root.querySelectorAll(REVEAL_SELECTOR).forEach(revealElement);
  }

  function isInViewport(element) {
    if (element.closest('[hidden]')) return false;

    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.92 && rect.bottom > window.innerHeight * 0.08;
  }

  function observeTarget(target, onReveal) {
    if (target.classList.contains(VISIBLE_CLASS)) return;

    if (isInViewport(target)) {
      onReveal(target);
      return;
    }

    observer?.observe(target);
  }

  function handleIntersection(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const target = entry.target;

      if (target.matches(ROOT_SELECTOR)) {
        revealChildren(target);
      } else {
        revealElement(target);
      }

      observer?.unobserve(target);
    });
  }

  function init(rootEl = document) {
    const roots = rootEl.querySelectorAll(ROOT_SELECTOR);
    const reveals = rootEl.querySelectorAll(REVEAL_SELECTOR);

    if (!roots.length && !reveals.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      reveals.forEach(revealElement);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      roots.forEach(revealChildren);
      reveals.forEach((element) => {
        if (!element.closest(ROOT_SELECTOR)) revealElement(element);
      });
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(handleIntersection, observerOptions);
    }

    roots.forEach((root) => {
      observeTarget(root, revealChildren);
    });

    reveals.forEach((element) => {
      if (element.closest(ROOT_SELECTOR)) return;
      observeTarget(element, revealElement);
    });
  }

  window.OfiyaaReveal = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
